<template>
  <div id="app">
    <transition name="fade">
      <BSLoading class="loading" v-if="!ready">
        Laster inn, vennligst vent et øyeblikk…
      </BSLoading>
    </transition>
    <template v-if="ready">
      <BSNavigation v-model="mode" class="nav" />
      <BSMap v-if="mode === 'map'" class="map" :stations="stations" />
      <BSList v-else class="list" :stations="stations" />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BSNavigation from './components/BSNavigation.vue'
import BSMap from './components/BSMap.vue'
import BSList from './components/BSList.vue'
import BSLoading from './components/BSLoading.vue'

export default {
  name: 'App',
  components: {
    BSNavigation,
    BSMap,
    BSList,
    BSLoading,
  },
  data() {
    return {
      mode: 'map',
      fetchingData: null,
    }
  },
  computed: {
    ...mapState({
      stations: s => s.stations,
      ready: s => s.ready,
    }),
  },
  methods: {
    fetchData() {
      this.fetchingData = setInterval(() => {
        this.$store.dispatch('fetchStations')
      }, 10000)
    },
  },
  created() {
    this.$store.dispatch('fetchStations')
    this.fetchData()
  },
  beforeDestroy() {
    clearInterval(this.fetchingData)
  },
}
</script>

<style lang="scss">
#app {
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.map,
.list {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.nav {
  z-index: 2;
}
.loading {
  z-index: 3;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
